<div class="hire-modal">
  <h2 class="modal-title">Nós produzimos a sua capa.</h2>
  <div class="modal-desc">
    Designers capistas profissionais com o selo de aprovação Feira do Livro estão a postos para ajudar a fazer o melhor trabalho
  </div>
  <div class="modal-price">
    Custo deste serviço R$ 499,00
  </div>
  <div class="modal-extra">
    Se você selecionar este serviço, entraremos em contato com após a finalização do livro para ajustar tudo pra você
  </div>
  <div class="modal-actions">
    <button class="back-btn" (click)="onBack()" [disabled]="isLoading">
      {{ isLoading ? 'Processando...' : 'Não, obrigado!' }}</button>
    <button class="continue-btn" (click)="onContinue()" [disabled]="isLoading">
      {{ isLoading ? 'Processando...' : 'Sim, contratar' }}
    </button>
  </div>
</div>